var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};

// src/util/environment-constants.ts
var ENVIRONMENT = /* @__PURE__ */ ((ENVIRONMENT2) => {
  ENVIRONMENT2["PRODUCTION"] = "production";
  ENVIRONMENT2["STAGING"] = "staging";
  ENVIRONMENT2["DEV"] = "development";
  return ENVIRONMENT2;
})(ENVIRONMENT || {});

// src/app-environment.ts
var _environment;
var AppEnvironmentClass = class {
  constructor() {
    __privateAdd(this, _environment, void 0);
  }
  init(environment) {
    if (!Object.values(ENVIRONMENT).includes(environment)) {
      throw Error("Environment value not supported.");
    }
    if (__privateGet(this, _environment)) {
      console.warn(
        `AppEnvironment has already been initialized with ${environment}.`
      );
    }
    if (!__privateGet(this, _environment)) {
      __privateSet(this, _environment, environment);
    }
  }
  get environment() {
    if (!__privateGet(this, _environment)) {
      throw Error("AppEnvironment needs to be initialized before use.");
    }
    return __privateGet(this, _environment);
  }
};
_environment = new WeakMap();
var AppEnvironment = new AppEnvironmentClass();

// src/util/environment-helpers.ts
var isProduction = () => AppEnvironment.environment === "production" /* PRODUCTION */;
var isStaging = () => AppEnvironment.environment === "staging" /* STAGING */;
var isDev = () => AppEnvironment.environment === "development" /* DEV */;
var isNodeTestEnv = () => {
  var _a;
  const nodeEnvPropName = "NODE_ENV";
  return typeof process !== "undefined" && ((_a = process.env) == null ? void 0 : _a[nodeEnvPropName]) === "test";
};
export {
  AppEnvironment,
  ENVIRONMENT,
  isDev,
  isNodeTestEnv,
  isProduction,
  isStaging
};
//# sourceMappingURL=index.js.map